module.exports = __webpack_public_path__ + "img/facebook-circle.377bfc96.png";